<template>
  <!-- 多页 -->
  <MultiIndex v-if="isShowGuide" :qdata="qdata" :begin="begin" />
</template>

<script>
import MultiIndex from './components/multi-index.vue';

export default {
  name: 'preview',
  components: { MultiIndex },
  data() {
    return {
      qdata: {},
      isShowGuide: false,
    };
  },
  methods: {
    // 跳到主页开始作答
    begin() {
      const qlist = this.qdata?.subject_config?.subjects || [];
      if (qlist.length > 0) {
        sessionStorage.setItem('questionnaire', JSON.stringify(this.qdata));
        this.$router.replace({
          name: 'question/subject',
          query: {
            is_preview: true,
          },
        });
      } else {
        this.$hll.toast('问卷题目数量异常');
      }
    },
    receiveMessage(event) {
      console.log('receiveMessage', event);
      if (event.data.type === 'data') {
        const qdata = event.data.params;
        this.qdata = JSON.parse(qdata);
        console.log('qdata', this.qdata);
        // 多页需要打开引导页，单页不需要
        if (this.qdata.page_type == 1) {
          this.begin();
        } else {
          this.isShowGuide = true;
        }
      }
    },
  },
  mounted() {
    //监听message事件
    window.addEventListener('message', this.receiveMessage, false);
  },
  destroyed() {
    window.removeEventListener('message', this.receiveMessage, false);
  },
};
</script>
